import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import {saveAs} from 'file-saver';
import { Link } from "react-router-dom";
import axios from 'axios';
import Resizer from "react-image-file-resizer";

// Icons and Style
import '../App2.css';
import downloadIcon from '../downloadIcon.png';
import editIcon from '../editIcon.png'; 
import ImagePlaceHolder from '../placeholder.jpeg'
import likeIcon from '../like.png'
import dislikeIcon from '../dislike.png'


//const localhostAPI = "http://127.0.0.1:5000";
const API = "https://generativeapp.com" 
  
export const Upload = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [prompt, setPrompt] = useState("A photo of ..."); 
  const [generatedImage, setGeneratedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false)  
  const [isRegisteringEmail, setIsRegisteringEmail] = useState(false)  
  const [email, setEmail] = useState("email")  

    const img2imgInference = () => {
      setIsLoading(true)
      const formData = new FormData()
      if (selectedImage) {
        formData.append("imageFile", selectedImage);
      }
      formData.append("prompt", prompt);
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      }
      axios.post(API + "/inference/img2img", formData, config)
      .then((res) => {
          setGeneratedImage(res.data.url)
          setIsLoading(false) 
        }).catch((error) => {
          if (error.response.status === 400) {
            alert("Upload Image and Provide Prompt.")
          }
          else{ 
            alert("Try again")
          }
          setIsLoading(false)
        });
  }

    const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        512,
        512,
        "JPEG",   
        100,
        0,     
        (file) => {
          resolve(file);
        },
        "file",
        "base64"
      );
    });
  
  const downloadGeneratedImage = () => {
    saveAs(generatedImage, "generated-image.png")
  }

  const registerEmail = () => {
    setIsRegisteringEmail(!isRegisteringEmail)
  }

  return (
      <>
      <div className="Nav">

        <div className="NavFirstHalf">
          <div className="NavTitle">
            <Link  className="NavLink" to={"/"}>
              Content<div className="NavAI">AI</div>
            </Link>
          </div>
        </div>
        
        <div className="NavSecondHalf">
          {
            isRegisteringEmail ? 
            <div className="EmailContainer">
            <TextField
            value={email}
            sx={{ input: { color: 'white'}}}
            style={{width: "100%"}}
            
            
            color="info"
            onChange={(e) => {
              setEmail(e.target.value);
            }} />
            <button className="RegisterEmailButton" onClick={registerEmail}>Register</button>
            </div>
          :
          <button className="btn btn-white" onClick={registerEmail}>Go Pro</button>

          }
        </div>

      </div>  
      
      <div className="AdsProductTitle">
        Augment Product Photos
        <input
            type="file"
            style={{ display: 'none' }}
            id="contained-button-file"
            onChange={ async (event) => {
              try {
                let file = event.target.files[0]
                const image = await resizeFile(file);
                setSelectedImage(image)
                setGeneratedImage(null)
              } catch (err) {
                console.log(err);
              }
            }}
          />
          <label htmlFor="contained-button-file">
            <Button variant="contained" color="primary" component="span" size='medium' style={{"marginTop":"10%"}}>
              Upload
            </Button>
          </label>
      </div>

      <div className="AdsBody">
        <div className="bodyFirstHalf">
            <div className="FirstHalfInnerBody">
              <div className="TextFieldTitle">Describe Transformation</div>
              
              <div style={{width: "60%"}}>
              <TextField
                
                inputProps={{ style: { fontFamily: 'Arial', color: 'white'}}}
                style={{width: "100%", "margin-bottom": "10px", flex: 1, margin: '0 0px 10px 0', color: 'white'}}
                
                variant="filled"
                placeholder="A photo of ..."
                multiline
                color="secondary"
                sx={{ input: { color: 'white'}}}
                value={prompt}
                onChange={(e) => {
                  setPrompt(e.target.value);
                }}
                label="creative prompt"
                rows={10}
              />
            

              {isLoading ? <Button> Generating </Button> :
                      <Button variant="contained" size="medium" color="secondary" onClick={img2imgInference}> Transform </Button> }
            </div>
          </div>
        </div>
        <div className="bodySecondHalf">
          <div className="SecondHalfInnerBody">
            <>
            {
              selectedImage ?

            <>
            { 
              isLoading ? 
              <div className="Loading2"><CircularProgress color="secondary" size="4rem"/></div> : 
              <>
              { 
                generatedImage ? 
               
                <div className="Download2">
                  <div className="imageContainer">
                    <img className="GeneratedImage2" src={generatedImage} alt=""/>
                  </div>
                  {/* Icons8.com */}
                  <div className="IconContainer2">
                    <div>
                      <img className="Icon2" src={downloadIcon} alt="download" title="download" onClick={downloadGeneratedImage}/>
                      <img className="Icon2" src={editIcon} alt="edit" title="edit"/>
                    </div>
                    <div>
                      <img className="Icon2" src={likeIcon} alt="like" title="like"/>
                      <img className="Icon2" src={dislikeIcon} alt="dislike" title="dislike"/>
                    </div>
                  </div>
                </div>  
                :
                <div className="Download2">
                  <img className="GeneratedImage2" src={URL.createObjectURL(selectedImage)} alt=""/>
                </div>
              }
              </>
            }
            </>
              :
              <div className="Download2">
                  <img className="GeneratedImage2" src={ImagePlaceHolder} alt=""/>
              </div>
            }
            </>
          </div>
        </div>
      </div>    
      </>
  );
}
  